import { PoolConfig, QuoteToken, PoolCategory } from './types'

const pools: PoolConfig[] = [
  // {
  //   sousId: 0,
  //   tokenName: 'CAKE',
  //   stakingTokenName: QuoteToken.CAKE,
  //   stakingTokenAddress: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
  //   contractAddress: {
  //     97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
  //     56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   projectLink: 'https://pancakeswap.finance/',
  //   harvest: true,
  //   tokenPerBlock: '10',
  //   sortOrder: 1,
  //   isFinished: false,
  //   tokenDecimals: 18,
  // },
  // {
  //   sousId: 1,
  //   tokenName: 'TWT',
  //   stakingTokenName: QuoteToken.SYRUP,
  //   stakingTokenAddress: '0x009cF7bC57584b7998236eff51b98A168DceA9B0',
  //   contractAddress: {
  //     97: '0xAfd61Dc94f11A70Ae110dC0E0F2061Af5633061A',
  //     56: '0xAfd61Dc94f11A70Ae110dC0E0F2061Af5633061A',
  //   },
  //   poolCategory: PoolCategory.CORE,
  //   projectLink: 'https://trustwallet.com/',
  //   harvest: true,
  //   tokenPerBlock: '20',
  //   sortOrder: 999,
  //   isFinished: true,
  //   tokenDecimals: 18,
  // },
    {
     sousId: 2,
     tokenName: 'ROMS',
     stakingTokenName: QuoteToken.SPOCK,
     stakingTokenAddress: '0xE2463256E69E4C86345DC32e2FFED3283b0022e8',
    contractAddress: {
       97: '0xAfd61Dc94f11A70Ae110dC0E0F2061Af5633061A',
       250: '0xBA139b08e8A8D3ba07Da9DEB23041aef4f342977',
     },
    poolCategory: PoolCategory.CORE,
     projectLink: 'https://borgswap.exchange',
    harvest: true,
   tokenPerBlock: '15000000000000000',
     sortOrder: 999,
     isFinished: false,
     tokenDecimals: 18,
   },
   {
    sousId: 3,
    tokenName: 'ROMS',
    stakingTokenName: QuoteToken.SPOCK,
    stakingTokenAddress: '0xE2463256E69E4C86345DC32e2FFED3283b0022e8',
   contractAddress: {
      97: '0xAfd61Dc94f11A70Ae110dC0E0F2061Af5633061A',
      250: '0x2C34D9C3D8AfDFDe02D4a3de10640c95455c30db',
    },
   poolCategory: PoolCategory.CORE,
    projectLink: 'https://borgswap.exchange',
   harvest: true,
  tokenPerBlock: '150000000000000000',
    sortOrder: 999,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 4,
    tokenName: 'BORG',
    stakingTokenName: QuoteToken.SPOCK,
    stakingTokenAddress: '0xE2463256E69E4C86345DC32e2FFED3283b0022e8',
   contractAddress: {
      97: '0xAfd61Dc94f11A70Ae110dC0E0F2061Af5633061A',
      250: '0xA7DeD77035027828Ee93A234aFb3F9c5c0Ff3aDd',
    },
   poolCategory: PoolCategory.CORE,
    projectLink: 'https://borgswap.exchange',
   harvest: true,
  tokenPerBlock: '70',
    sortOrder: 999,
    isFinished: false,
    tokenDecimals: 8,
  },
  {
    sousId: 5,
    tokenName: 'JEMHAD',
    stakingTokenName: QuoteToken.SPOCK,
    stakingTokenAddress: '0xE2463256E69E4C86345DC32e2FFED3283b0022e8',
   contractAddress: {
      97: '0xAfd61Dc94f11A70Ae110dC0E0F2061Af5633061A',
      250: '0xFe4577e0F3989939628B08BfF5e0Ae86DD8Ffa75',
    },
   poolCategory: PoolCategory.CORE,
    projectLink: 'https://borgswap.exchange',
   harvest: true,
  tokenPerBlock: '15000',
    sortOrder: 999,
    isFinished: false,
    tokenDecimals: 18,
  },
]

export default pools
